import { GET_CONTRACTED_HOURS_BY_ID_SUCCESS, GET_CONTRACTED_HOURS_BY_ID_FAILURE } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case GET_CONTRACTED_HOURS_BY_ID_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case GET_CONTRACTED_HOURS_BY_ID_FAILURE:
      return { ...state, isLoading: false, errorData: action.payload, error: true };
    default:
      return { ...state };
  }
};
